<template>
  <div class="w-full h-10 w-full flex flex-row items-center relative">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    //value is the current step
    value: {
      type: Number,
      default: 0
    }
  },
  name: 'ZStepper'
}
</script>

<style scoped></style>
